/*
    Тип карточки для панели дашборда
*/
export enum SensorType {
  Sensor = 'sensor',
  Component = 'component',
}

/**
 * Перечень обрабатываемых событий.
 */
export enum EventName {
  DeviceChanged = 'device_changed',
  ErrorOccurred = 'error_occurred',
  BoundaryPassed = 'boundary_passed',
}
